import { Button, Collapse } from "components/Core"
import { Select } from "flowbite-react"
import { useContext, useEffect, useState } from "react"
import { AppContext } from "store/context/AppContext"

interface IFieldBool {
  field: any
  apply_filter: any
}

const FieldBool = ({ field: _field, apply_filter }: IFieldBool) => {
  const { filters_table } = useContext(AppContext)
  const { id, label, options } = _field
  const [value, set_value] = useState<string>("")

  useEffect(() => {
    if (Object.keys(filters_table.state).length === 0) {
      set_value("")
    }
  }, [filters_table.state])

  const handle_change_value = (e: any) => {
    e.preventDefault()
    set_value(e?.target?.value)
  }

  const apply_filter_value = () => {
    apply_filter({ ..._field, value: Boolean(JSON.parse(value)) })
  }

  return (
    <Collapse name={id} header={<h1>{label}</h1>}>
      <div className="w-full flex flex-row items-center justify-center gap-2">
        <div className="relative w-full h-14">
          <Select onChange={handle_change_value} value={value} className="w-full h-full">
            {options.length ? (
              <>
                <option value="" disabled>
                  <p>Seleccione...</p>
                </option>
                {options.map((item: any, i: number) => (
                  <option key={i} value={item?.value}>
                    <p>{item?.label}</p>
                  </option>
                ))}
              </>
            ) : (
              <option disabled>Sin opciones</option>
            )}
          </Select>
        </div>
        <Button label="Aplicar" disabled={Boolean(!value)} className="w-28 !p-0" onClick={apply_filter_value} />
      </div>
    </Collapse>
  )
}

export default FieldBool
